import React, { Profiler } from "react";
import clsx from "clsx";
import "./chat-box-list-view.styles.scss";

import { $Logger } from "../../../logger";
import { ChatBoxList } from "../ChatBoxList";
import {
	useChatBoxViewContext,
	useChatBoxListUIController,
	useChatBoxListState,
} from "../../contexts";
import { useCBLAnimationNG } from "../../core/engines";

export interface ChatBoxListViewProps {
	className?: string;
	scrollerElementId: string;
}

const BlockName = "chat-box-list-view";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {
		ChatBoxList: `${BlockName}__chat-box-list`,
	},
} as const;

export type ChatBoxListViewComponent = React.FC<ChatBoxListViewProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxListView = ((props: ChatBoxListViewProps) => {
	const containerRef = React.useRef<HTMLDivElement>(null);

	const { toUidInfo, fromUidInfo } = useChatBoxViewContext();
	const controller = useChatBoxListUIController();
	const state = useChatBoxListState();
	const animationNG = useCBLAnimationNG();

	function blockMainThread(duration: number) {
		const end = Date.now() + duration;
		while (Date.now() < end) {}
		console.log("[@dongmt] Main thread unblocked after " + duration + "ms");
		return "done";
	}

	const handleScroll = (event: any) => {
		console.log("dongmt handleScroll");
		// if (Math.random() <= 0.1) {
		// 	blockMainThread(100);
		// }
	};

	return (
		// <Profiler id="ChatBoxListView" onRender={console.log}>
			<div
				id={props.scrollerElementId}
				ref={(container) => {
					containerRef.current = container;
					controller.scroller.bindScrollableContainer(container);
					animationNG.bindScrollableContainer(container);
				}}
				className={clsx(ChatBoxListView.ClassNames.Block, props.className)}
				onScroll={handleScroll}
			>
				<ChatBoxList
					className={ChatBoxListView.ClassNames.Elements.ChatBoxList}
					scrollerElementId={props.scrollerElementId}
					toUidInfo={toUidInfo}
					fromUidInfo={fromUidInfo}
					state={state}
					controller={controller}
					animationNG={animationNG}
					containerRef={containerRef}
				/>
			</div>
		// </Profiler>
	);
}) as ChatBoxListViewComponent;
ChatBoxListView.ClassNames = ClassNames;
